import React from 'react';

import PropTypes from 'prop-types';
import {
    Label,
    Slider as SliderBase,
    SliderOutput,
    SliderTrack,
    SliderThumb,
} from 'react-aria-components';

import {
    combineClasses,
} from 'wanderu-css';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Slider.scss';

const getStyles = (state) => {
    const curr = state.getThumbPercent(0);
    const next = state.getThumbPercent(1);
    const length = state?.values?.length;

    if (length === 1) {
        return { width: curr * 100 + '%' };
    }

    if (next && curr !== next) {
        return {
            left: curr * 100 + '%',
            width: (next - curr) * 100 + '%',
        };
    }

    return {};
};

function Slider(props) {
    const {
        classes: classesProp = {},
        label,
        showOutput,
        thumbLabels,
    } = props;
    const classes = combineClasses(styles, classesProp);

    return (
        <SliderBase className={classes.slider} {...props}>
            {label && <Label className={classes.label}>{label}</Label>}
            {showOutput && <SliderOutput className={classes.output}>
                {({ state }) => state.values.map((_, i) => state.getThumbValueLabel(i)).join(' – ')}
            </SliderOutput>}
            <SliderTrack className={classes.track}>
                {({ state }) => (
                    <>
                        <div
                            className={classes.fill}
                            style={getStyles(state)}
                        />
                        {state.values.map((_, index) => (
                            <SliderThumb
                                aria-label={thumbLabels?.[index]}
                                className={classes.thumb}
                                index={index}
                                key={index}
                            />
                        ))}
                    </>
                )}
            </SliderTrack>
        </SliderBase>
    );
}

Slider.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * The text describing the slider
     */
    label: PropTypes.string,
    /**
     * Whether to show the raw output of the slider, ie 0-100
     */
    showOutput: PropTypes.bool,
    /**
     * The aria labels for the handles of the slider
     */
    thumbLabels: PropTypes.arrayOf(PropTypes.string),
};

export default Slider;
